// Japanese translations
const common = {
  "nav.home": "ホーム",
  "nav.generator": "AI生成器",
  "nav.pricing": "料金",
  "nav.login": "ログイン / 登録",
  "nav.startFree": "無料で始める",
  "nav.memberCenter": "メンバーセンター",
  "nav.logout": "ログアウト",

  "hero.badge": "永久無料 • ログイン不要",
  "hero.title1": "無料AI画像",
  "hero.title2": "ジェネレーター",
  "hero.subtitle":
    "AIで瞬時にアイデアを美しいビジュアルに変換。\n登録不要、無制限生成、完全無料。",
  "hero.ctaPrimary": "無料で作成開始",
  "hero.ctaSecondary": "使い方を見る",
  "hero.trust1": "クレジットカード不要",
  "hero.trust2": "無制限使用",
  "hero.trust3": "商用利用可",

  "features.badge": "機能",
  "features.title": "強力なAI画像生成",
  "features.subtitle":
    "クリエイター向けに設計された最先端機能で次世代AI画像作成を体験",
  "features.f1.title": "テキストから画像",
  "features.f1.desc":
    "高度なAIモデルで言葉を美しいビジュアルに変換。見たいものを説明するだけ。",
  "features.f2.title": "画像から画像",
  "features.f2.desc":
    "任意の画像をアップロードして、異なるスタイルに変換したり品質を向上させたりできます。",
  "features.f3.title": "スタイル転送",
  "features.f3.desc":
    "画像にアーティスティックなスタイルを適用。リアルからアニメ、油絵からデジタルアートまで。",
  "features.f4.title": "超高速",
  "features.f4.desc":
    "最適化されたAIインフラで数秒でプロ品質の画像を生成。",
  "features.f5.title": "プライバシー保護",
  "features.f5.desc":
    "ゼロデータ保持ポリシー。プロンプトや画像はサーバーに保存されません。",
  "features.f6.title": "無制限・無料",
  "features.f6.desc":
    "使用制限なし、クレジットカード不要、登録不要。永遠に好きなだけ作成できます。",

  "gallery.badge": "ギャラリー",
  "gallery.title": "インスピレーションを得る",
  "gallery.subtitle": "コミュニティが作成した素晴らしいAI生成画像を探索",
  "gallery.cta": "自分で作成する",
  "gallery.clickToUse": "クリックして使用",
  "gallery.copyPrompt": "プロンプトをコピー",
  "gallery.copied": "コピーしました！",
  "gallery.usePrompt": "これを使う",
  "gallery.hoverTip": "画像にカーソルを合わせてプロンプトをコピーまたは使用",

  "stats.title": "数百万人に信頼されています",
  "stats.subtitle":
    "世界最大の無料AI画像生成コミュニティに参加しよう",
  "stats.s1.label": "アクティブユーザー",
  "stats.s1.value": "300万+",
  "stats.s1.desc": "月間アクティブユーザー",
  "stats.s2.label": "生成画像数",
  "stats.s2.value": "1,530",
  "stats.s2.desc": "1分あたりの生成画像数",
  "stats.s3.label": "ユーザー評価",
  "stats.s3.value": "4.9",
  "stats.s3.desc": "平均品質評価",

  "testimonials.badge": "お客様の声",
  "testimonials.title": "クリエイターの声",
  "testimonials.subtitle":
    "クリエイターがAIを使って生産性を向上させる方法をご覧ください",
  "testimonials.ratings":
    "25,017件以上のユーザー評価に基づく、平均4.9/5つ星",
  "testimonials.t1.name": "Sophie Miller",
  "testimonials.t1.role": "フリーランスデザイナー",
  "testimonials.t1.content":
    "このAI画像生成器で創造的な効率が10倍になりました！画像品質は想像を超えており、商業要件を完璧に満たしています。",
  "testimonials.t2.name": "Michael Chen",
  "testimonials.t2.role": "クリエイティブディレクター",
  "testimonials.t2.content":
    "高度な機能で細部まで正確にコントロールできます。市場で最も強力なAI画像生成器です！",
  "testimonials.t3.name": "Sarah Wang",
  "testimonials.t3.role": "ECマネージャー",
  "testimonials.t3.content":
    "ECマネージャーとして、このツールで商品画像を素早く生成できます。他のAIツールよりはるかに優れています！",
  "testimonials.t4.name": "David Liu",
  "testimonials.t4.role": "ブランドデザイナー",
  "testimonials.t4.content":
    "エディターでブランドスタイルの一貫性を保てます。このAI画像生成器は本当に私のニーズを理解しています。",
  "testimonials.t5.name": "Emma Zhang",
  "testimonials.t5.role": "コンテンツクリエイター",
  "testimonials.t5.content":
    "速度が驚異的！数秒でプロ品質の画像が生成され、プロジェクトサイクルが大幅に短縮されました。",
  "testimonials.t6.name": "Kevin Wu",
  "testimonials.t6.role": "ゲームコンセプトアーティスト",
  "testimonials.t6.content":
    "ディテール表現は比類なし。ゲーム開発者として、コンセプトデザインの定番ツールになっています。",

  "cta.title1": "素晴らしいAIアートを",
  "cta.title2": "作成する準備はできていますか？",
  "cta.subtitle":
    "世界で最も強力な無料AI画像生成器を使う数百万人のクリエイターに参加しよう",
  "cta.button": "最初の画像を無料で生成",
  "cta.note": "クレジットカード不要 • 登録不要 • 無制限生成",

  "faq.badge": "よくある質問",
  "faq.title": "よくある質問",
  "faq.contact":
    "他にご質問がありますか？support@aiimagegenrator.comまでお問い合わせください",
  "faq.q1": "このAI画像生成器とは何ですか？どのように機能しますか？",
  "faq.a1":
    "当社のAI画像生成器は、世界初の完全無料・無制限のAI画像作成ツールです。登録や使用制限なしに高品質な画像を作成できます。",
  "faq.q2": "このAI画像生成器は本当に無料ですか？",
  "faq.a2": "はい、完全無料です！隠れた料金なし、クレジットカード不要、使用制限なしです。",
  "faq.q3": "他のAI画像生成器と何が違いますか？",
  "faq.a3":
    "複数のAIモデルにわたるインテリジェントルーティングで無制限の無料使用を提供する唯一のプラットフォームです。",
  "faq.q4": "使用するためにアカウントを作成する必要がありますか？",
  "faq.a4": "アカウント不要！すぐに画像生成を開始できます。",
  "faq.q5": "どのような種類の画像を作成できますか？",
  "faq.a5":
    "リアルなシーン、芸術的なイラスト、デジタルアート、アニメスタイルの画像など様々な種類を作成できます。",
  "faq.q6": "プライバシーはどのように保護されますか？",
  "faq.a6":
    "プロンプトや生成された画像はサーバーに保存されません。個人情報も不要です。",
  "faq.q7": "生成した画像を商業目的で使用できますか？",
  "faq.a7":
    "はい、生成した画像の権利はあなたのものです。個人・商業目的の両方で使用できます。",
  "faq.q8": "モバイルデバイスで利用できますか？",
  "faq.a8":
    "現在、モバイルブラウザで動作するウェブサイトからアクセスできます。専用モバイルアプリも開発中です。",

  "pricing.title": "シンプルで透明な料金",
  "pricing.subtitle": "クリエイティブなニーズに合った完璧なプランを選択",
  "pricing.monthly": "月払い",
  "pricing.yearly": "年払い",
  "pricing.save17": "17%お得",
  "pricing.popular": "最も人気",
  "pricing.guarantee": "30日間返金保証",
  "pricing.loginPrompt": "Proにアップグレードするには先にログインしてください",
  "pricing.free.name": "無料",
  "pricing.free.desc": "AI画像生成を試すのに最適",
  "pricing.free.cta": "無料で始める",
  "pricing.free.f1": "1日10枚",
  "pricing.free.f2": "標準品質 (512x512)",
  "pricing.free.f3": "基本スタイル・フィルター",
  "pricing.free.f4": "コミュニティサポート",
  "pricing.free.f5": "透かし入り画像",
  "pricing.free.f6": "標準生成速度",
  "pricing.pro.name": "Pro",
  "pricing.pro.desc": "プロフェッショナルとコンテンツクリエイター向け",
  "pricing.pro.cta": "Proにアップグレード",
  "pricing.pro.f1": "無制限画像",
  "pricing.pro.f2": "高品質 (1024x1024)",
  "pricing.pro.f3": "プレミアムスタイル・フィルター",
  "pricing.pro.f4": "優先サポート",
  "pricing.pro.f5": "透かしなし",
  "pricing.pro.f6": "高速生成",
  "pricing.pro.f7": "バッチ生成（最大10枚）",
  "pricing.pro.f8": "商用ライセンス",
  "pricing.pro.f9": "高度なAIモデル",
  "pricing.pro.f10": "画像アップスケーリング",
  "pricing.pro.saveYear": "$30/年お得",
  "pricing.paypalCheckout": "PayPalでサブスクリプションを完了",
  "pricing.cancelPayment": "キャンセル",
  "pricing.subscriptionSuccess": "サブスクリプション成功！Proへようこそ！",

  "compare.title": "詳細比較",
  "compare.subtitle": "各プランに含まれる内容を確認",
  "compare.feature": "機能",
  "compare.free": "無料",
  "compare.pro": "Pro",
  "compare.f1": "画像生成数",
  "compare.v1.free": "無制限",
  "compare.v1.pro": "無制限",
  "compare.f2": "最大解像度",
  "compare.v2.free": "1024x1024",
  "compare.v2.pro": "4096x4096",
  "compare.f3": "生成速度",
  "compare.v3.free": "標準",
  "compare.v3.pro": "3倍速",
  "compare.f4": "バッチ生成",
  "compare.v4.free": "5枚",
  "compare.v4.pro": "20枚",
  "compare.f5": "スタイルオプション",
  "compare.v5.free": "基本",
  "compare.v5.pro": "高度",
  "compare.f6": "編集ツール",
  "compare.v6.free": "基本",
  "compare.v6.pro": "高度",
  "compare.f7": "広告",
  "compare.v7.free": "あり",
  "compare.v7.pro": "なし",
  "compare.f8": "優先サポート",
  "compare.v8.free": "なし",
  "compare.v8.pro": "あり",
  "compare.f9": "商用ライセンス",
  "compare.v9.free": "あり",
  "compare.v9.pro": "あり",
  "compare.f10": "透かし",
  "compare.v10.free": "なし",
  "compare.v10.pro": "なし",

  "gen.title": "AI画像生成器",
  "gen.subtitle":
    "AIで美しい画像を作成 - 無料、無制限、ログイン不要",
  "gen.mode": "生成モード",
  "gen.textToImage": "テキストから画像",
  "gen.imageToImage": "画像から画像",
  "gen.aspectRatio": "アスペクト比",
  "gen.style": "スタイル",
  "gen.style.none": "スタイルなし",
  "gen.style.realistic": "リアル",
  "gen.style.anime": "アニメ",
  "gen.style.artistic": "アーティスティック",
  "gen.style.digital": "デジタルアート",
  "gen.promptLabel": "作成したいものを説明してください",
  "gen.promptPlaceholder":
    "鮮やかな色彩の山の上の美しい夕日...",
  "gen.promptTip":
    "💡 ヒント：最良の結果を得るために具体的に説明してください",
  "gen.uploadLabel": "ソース画像をアップロード",
  "gen.uploadHint": "クリックしてアップロードまたはドラッグ＆ドロップ",
  "gen.uploadSize": "PNG、JPG 最大10MB",
  "gen.generateBtn": "画像を生成",
  "gen.free": "無料",
  "gen.resultPlaceholder": "生成された画像がここに表示されます",
  "gen.emptyPrompt": "画像を生成するにはプロンプトを入力してください",
  "gen.promptPrefilled": "✨ ギャラリーからプロンプトが入力されました！生成ボタンをクリックして画像を作成してください。",
  "gen.clearPrompt": "クリア",

  // ジェネレータータブ & 新キー
  "gen.tabSingle": "単一画像",
  "gen.tabBatch": "バッチ生成",
  "gen.tabHistory": "履歴",
  "gen.successMsg": "画像が正常に生成されました！",
  "gen.generating": "生成中...",
  "gen.download": "画像をダウンロード",
  "gen.new": "新規",

  // 画像履歴
  "history.title": "生成履歴",
  "history.empty": "まだ画像が生成されていません",
  "history.emptyHint": "生成した画像がここに表示されます",
  "history.clearAll": "すべてクリア",
  "history.clearConfirmTitle": "すべての履歴をクリアしますか？",
  "history.clearConfirmDesc": "すべての生成履歴が完全に削除されます。この操作は元に戻せません。",
  "history.cancel": "キャンセル",
  "history.clearConfirm": "すべてクリア",
  "history.reuse": "このプロンプトを使用",
  "history.download": "ダウンロード",
  "history.copyPrompt": "プロンプトをコピー",
  "history.justNow": "たった今",
  "history.minutesAgo": "{{count}}分前",
  "history.hoursAgo": "{{count}}時間前",
  "history.daysAgo": "{{count}}日前",

  // バッチ生成
  "batch.title": "バッチ生成",
  "batch.badge": "Pro機能",
  "batch.countLabel": "生成する画像の数",
  "batch.images": "枚",
  "batch.generateBtn": "{{count}}枚の画像を生成",
  "batch.generating": "生成中",
  "batch.progressText": "{{done}} / {{total}} 枚完了",
  "batch.results": "生成結果",
  "batch.downloadAll": "すべてダウンロード",
  "batch.hint": "左側にプロンプトを入力して、複数のバリエーションを一度に生成",

  // 画像から動画
  "gen.tabI2V": "画像から動画",
  "i2v.title": "画像から動画",
  "i2v.uploadTitle": "画像をアップロードまたは貼り付け",
  "i2v.uploadHint": "クリックしてアップロード、ドラッグ＆ドロップ、またはCtrl+Vで貼り付け",
  "i2v.uploadFormats": "PNG、JPG、WebP 最大20MB",
  "i2v.changeImage": "変更",
  "i2v.effectLabel": "モーションエフェクト",
  "i2v.effectZoomIn": "ズームイン",
  "i2v.effectZoomOut": "ズームアウト",
  "i2v.effectPanLeft": "左パン",
  "i2v.effectPanRight": "右パン",
  "i2v.effectPanUp": "上パン",
  "i2v.generateBtn": "動画を生成",
  "i2v.generating": "生成中",
  "i2v.progressHint": "フレームをレンダリング中、お待ちください...",
  "i2v.success": "動画が正常に生成されました！",
  "i2v.download": "動画をダウンロード",
  "i2v.regenerate": "再生成",
  "i2v.error": "動画の生成に失敗しました。もう一度お試しください。",
  "i2v.invalidFile": "有効な画像ファイルを選択してください。",
  "i2v.fileTooLarge": "ファイルが大きすぎます。最大20MBです。",

  "footer.stayUpdated": "最新情報を入手",
  "footer.newsletter":
    "新機能やAI画像生成のヒントに関する最新情報を入手",
  "footer.emailPlaceholder": "メールアドレス",
  "footer.subscribe": "登録する",
  "footer.product": "製品",
  "footer.features": "機能",
  "footer.company": "会社",
  "footer.legal": "法的情報",
  "footer.aiGenerator": "AI生成器",
  "footer.pricing": "料金",
  "footer.textToImage": "テキストから画像",
  "footer.imageToImage": "画像から画像",
  "footer.styleTransfer": "スタイル転送",
  "footer.aboutUs": "会社概要",
  "footer.contact": "お問い合わせ",
  "footer.privacy": "プライバシーポリシー",
  "footer.terms": "利用規約",
  "footer.copyright":
    "© 2025 AI Image Generator. All rights reserved.",
  "footer.poweredBy": "Powered by Readdy",

  // Pro Banner
  "proBanner.badge": "期間限定オファー",
  "proBanner.title": "Proで究極のクリエイティブパワーを解放",
  "proBanner.subtitle": "4K解像度、3倍速生成、バッチ処理、広告なしで、AIアートを次のレベルへ。",
  "proBanner.f1": "3倍速",
  "proBanner.f2": "4K解像度",
  "proBanner.f3": "バッチ生成",
  "proBanner.f4": "広告なし",
  "proBanner.discount": "48%オフ — 期間限定",
  "proBanner.cta": "今すぐProにアップグレード",
  "proBanner.guarantee": "30日間返金保証",

  // Member Center
  "member.loginRequired": "ログインが必要です",
  "member.loginDesc": "メンバーセンターにアクセスしてサブスクリプションを管理するにはログインしてください。",
  "member.backHome": "ホームに戻る",
  "member.freePlan": "無料プラン",
  "member.proPlan": "Proプラン",
  "member.currentPlan": "現在のプラン",
  "member.planType": "プランタイプ",
  "member.freePlanLabel": "無料",
  "member.resolution": "最大解像度",
  "member.speed": "生成速度",
  "member.speedStandard": "標準",
  "member.speed3x": "3倍速",
  "member.batch": "バッチ生成",
  "member.batch5": "最大5枚",
  "member.batch20": "最大20枚",
  "member.watermark": "透かし",
  "member.noWatermark": "透かしなし",
  "member.hasWatermark": "あり",
  "member.usageStats": "使用統計",
  "member.todayUsage": "今日の使用量",
  "member.totalGenerated": "累計生成数",
  "member.memberSince": "登録日",
  "member.upgradeTitle": "Proにアップグレードして完全な体験を",
  "member.upgradeDesc": "4K解像度、3倍速、バッチ生成、透かしなし、広告なしを解放。",
  "member.upgradeCta": "Proにアップグレード",
  "member.proBenefits": "あなたのPro特典",
  "member.benefit1": "無制限画像",
  "member.benefit2": "4K解像度",
  "member.benefit3": "3倍速生成",
  "member.benefit4": "バッチ生成",
  "member.benefit5": "広告なし",
  "member.benefit6": "商用ライセンス",
};

export default common;
